import React, { useState } from "react";
import { useConfig } from "@/context/ConfigContext";
import { Megaphone, X } from "lucide-react";

const TONES = { info: "bg-teal-500/10 text-teal-600 dark:text-teal-300 border-teal-500/30", warning: "bg-amber-500/10 text-amber-600 dark:text-amber-300 border-amber-500/30", success: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-300 border-emerald-500/30" };

export default function TopBanners() {
  const { announcement, theme } = useConfig();
  const [dismissed, setDismissed] = useState(sessionStorage.getItem("bf_ann_dismissed") === "1");

  const showAnn = announcement?.enabled && announcement?.message && !dismissed;
  const showTheme = theme?.banner;
  if (!showAnn && !showTheme) return null;

  return (
    <div className="space-y-2 mb-4">
      {showAnn && (
        <div className={`flex items-center gap-2 px-4 py-2.5 rounded-xl border text-sm font-medium ${TONES[announcement.tone] || TONES.info}`} data-testid="announcement-banner">
          <Megaphone className="h-4 w-4 shrink-0" />
          <span className="flex-1">{announcement.message}</span>
          <button onClick={() => { sessionStorage.setItem("bf_ann_dismissed", "1"); setDismissed(true); }} className="p-0.5 rounded hover:bg-black/10"><X className="h-4 w-4" /></button>
        </div>
      )}
      {showTheme && (
        <div className="flex items-center justify-center gap-2 px-4 py-2 rounded-xl border text-sm font-semibold" data-testid="theme-banner"
          style={{ borderColor: (theme.accent || "#14B8A6") + "55", background: (theme.accent || "#14B8A6") + "18", color: theme.accent || "#14B8A6" }}>
          {theme.emoji && <span className="text-base">{theme.emoji}</span>} {theme.banner}
        </div>
      )}
    </div>
  );
}
